import {
  type DocumentData,
  limit,
  type QueryConstraint,
  where,
} from "firebase/firestore";
import { firestoreApi } from "../core/apis/firestoreApi";
import BaseApi from "../core/BaseApi";
import UserModel, { type UserModelData } from "./UserModel";

export default class UsersApi extends BaseApi<UserModel, UserModelData> {
  /* PRIVATE APIS */

  async getBusinessUser(superUserUid: string, businessPlanuid: string) {
    const qs: QueryConstraint[] = [
      where("businessPlanUid", "==", businessPlanuid),
      where("authedUsers", "array-contains", superUserUid),
      limit(1),
    ];

    const querySnapshot = await firestoreApi.queryDocuments(this.db, ...qs);

    if (querySnapshot[0]) {
      const user = this.fromFirestore(querySnapshot[0]);
      this.store.load([user]);
      return user;
    }
  }

  async getBusinessUserByEmail(email: string, businessPlanuid: string) {
    const qs: QueryConstraint[] = [
      where("businessPlanUid", "==", businessPlanuid),
      where("email", "==", email),
      limit(1),
    ];

    const querySnapshot = await firestoreApi.queryDocuments(this.db, ...qs);

    if (querySnapshot[0]) {
      const user = this.fromFirestore(querySnapshot[0]);
      this.store.load([user]);
      return user;
    }
  }

  /* NEEDED BASE API OVERRIDES */

  get db() {
    return `${this.dbPrefix}users`;
  }

  get store() {
    return this.stores.usersStore;
  }

  fromFirestore(res: DocumentData): UserModel {
    return new UserModel(this.stores, this.api, {
      uid: res.id,
      ...res.data(),
    });
  }
}
